import React from 'react';

function UnauthorizedIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 200 200" fill="none">
      <g clipPath="url(#clip0_13144_150815)">
        <path
          d="M100 200C155.228 200 200 155.228 200 100C200 44.7715 155.228 0 100 0C44.7715 0 0 44.7715 0 100C0 155.228 44.7715 200 100 200Z"
          fill="white"
        />
        <path
          d="M200 100C200 101.796 199.954 103.583 199.858 105.358C199.833 105.862 199.8 106.371 199.762 106.875C199.429 111.8 198.737 116.621 197.717 121.321C196.821 125.438 195.675 129.454 194.292 133.363C193.075 136.808 191.675 140.167 190.096 143.429C190.012 143.613 189.925 143.792 189.837 143.971C186.367 151.05 182.083 157.658 177.108 163.675C158.767 185.858 131.033 200 100 200C68.9667 200 41.2333 185.863 22.8917 163.675C12.9167 151.608 5.72083 137.167 2.27917 121.321C0.783333 114.45 0 107.317 0 99.9958C0 98.7417 0.025 97.4917 0.0708333 96.25V96.2333L90.775 77.8917L122.571 71.4625V66.2042L92.0708 60.0375L90.625 59.7458L16.6167 44.7833C16.6167 44.7833 16.6208 44.775 16.625 44.7708C34.5292 17.7875 65.1875 0 100 0C139.371 0 173.425 22.75 189.737 55.825C194.004 64.4708 197.054 73.825 198.671 83.6583C199.546 88.975 200 94.4333 200 100Z"
          fill="#09294A"
        />
        <path
          d="M197.721 121.325C194.28 137.171 187.084 151.613 177.109 163.679C158.767 185.863 131.034 200.004 100 200.004C68.967 200.004 41.2337 185.867 22.892 163.679C12.917 151.613 5.72121 137.171 2.27954 121.325H197.721Z"
          fill="#4B78AA"
        />
        <path
          d="M199.767 106.875C199.434 111.8 198.742 116.621 197.721 121.321C196.825 125.438 195.679 129.454 194.296 133.363C193.079 136.808 191.679 140.167 190.1 143.429H49.1169C49.1169 143.429 96.6461 119.225 110.238 112.075C123.834 104.929 136.621 118.129 150.284 120.008C166.459 122.233 182.213 115.183 196.642 108.354C197.684 107.858 198.725 107.371 199.767 106.875Z"
          fill="#204B7A"
        />
        <path
          d="M177.108 163.675C158.766 185.858 131.033 200 99.9997 200C68.9664 200 41.233 185.862 22.8914 163.675H177.108Z"
          fill="#4B78AA"
        />
        <path
          d="M194.296 133.367C193.013 137 191.521 140.542 189.842 143.971C186.371 151.05 182.088 157.658 177.113 163.675H31.2043C48.3793 155.754 66.146 149.158 84.3002 143.971C89.0668 142.604 93.8585 141.337 98.6752 140.167C112.609 136.783 127.154 134.212 141.204 137.071C150.15 138.887 158.784 142.883 167.904 142.746C177.404 142.604 185.842 138.112 194.296 133.362V133.367Z"
          fill="#09294A"
        />
        <path
          d="M146.913 153.233H114.117L122.646 79.4959L130.517 71.1334L138.384 79.4959L146.913 153.233Z"
          fill="white"
        />
        <path
          d="M49.2083 13.8375C64.0958 5.04583 81.4583 0 99.9999 0C112.562 0 124.579 2.31667 135.654 6.54583C127.558 6.49583 119.35 8.65833 111.837 11.85C100.821 16.5333 90.8458 23.3292 80.2958 28.9917C76.9208 30.8042 73.3666 32.5333 69.5416 32.7792C65.7166 33.025 61.5416 31.4542 59.7458 28.0667C58.2124 25.1708 58.6541 21.5333 57.1166 18.6417C55.6083 15.8083 52.4124 14.2125 49.2041 13.8375H49.2083Z"
          fill="#09294A"
        />
        <path
          d="M59.9954 104.213C60.4833 104.213 60.8787 103.817 60.8787 103.329C60.8787 102.841 60.4833 102.446 59.9954 102.446C59.5075 102.446 59.1121 102.841 59.1121 103.329C59.1121 103.817 59.5075 104.213 59.9954 104.213Z"
          fill="white"
        />
        <path
          d="M71.3962 24.0542C71.5596 24.0542 71.692 23.9217 71.692 23.7584C71.692 23.595 71.5596 23.4625 71.3962 23.4625C71.2328 23.4625 71.1003 23.595 71.1003 23.7584C71.1003 23.9217 71.2328 24.0542 71.3962 24.0542Z"
          fill="white"
        />
        <path
          d="M83.5252 89.2082C83.8497 89.2082 84.1127 88.9452 84.1127 88.6207C84.1127 88.2963 83.8497 88.0332 83.5252 88.0332C83.2008 88.0332 82.9377 88.2963 82.9377 88.6207C82.9377 88.9452 83.2008 89.2082 83.5252 89.2082Z"
          fill="white"
        />
        <path
          d="M114.117 54.1291C114.442 54.1291 114.705 53.8661 114.705 53.5416C114.705 53.2171 114.442 52.9541 114.117 52.9541C113.793 52.9541 113.53 53.2171 113.53 53.5416C113.53 53.8661 113.793 54.1291 114.117 54.1291Z"
          fill="white"
        />
        <path
          d="M153.571 107.667C153.734 107.667 153.866 107.534 153.866 107.371C153.866 107.207 153.734 107.075 153.571 107.075C153.407 107.075 153.275 107.207 153.275 107.371C153.275 107.534 153.407 107.667 153.571 107.667Z"
          fill="white"
        />
        <path
          d="M101.171 68.6209C101.495 68.6209 101.758 68.3579 101.758 68.0334C101.758 67.7089 101.495 67.4459 101.171 67.4459C100.847 67.4459 100.583 67.7089 100.583 68.0334C100.583 68.3579 100.847 68.6209 101.171 68.6209Z"
          fill="white"
        />
        <path
          d="M12.9378 103.917C13.2623 103.917 13.5253 103.654 13.5253 103.329C13.5253 103.005 13.2623 102.742 12.9378 102.742C12.6134 102.742 12.3503 103.005 12.3503 103.329C12.3503 103.654 12.6134 103.917 12.9378 103.917Z"
          fill="white"
        />
        <path
          d="M163.683 87.6458C163.927 87.6458 164.125 87.4481 164.125 87.2041C164.125 86.9602 163.927 86.7625 163.683 86.7625C163.439 86.7625 163.241 86.9602 163.241 87.2041C163.241 87.4481 163.439 87.6458 163.683 87.6458Z"
          fill="white"
        />
        <path d="M138.875 83.7543H122.154L115.517 80.8126H145.517L138.875 83.7543Z" fill="#C0C0C0" />
        <path
          d="M134.192 142.796V153.237H126.837V142.796C126.837 140.767 128.483 139.121 130.512 139.121C132.542 139.121 134.187 140.767 134.187 142.796H134.192Z"
          fill="#FFC600"
        />
        <path
          d="M192.179 61.1667C190.088 60.8584 188.017 60.4 186.004 59.8209C176.746 57.1667 168.321 52.2667 159.629 48.1167C150.934 43.9709 141.55 40.4959 131.934 41.0334C117.088 41.8625 104.838 51.8084 92.0753 60.0417L16.6169 44.7834C24.9836 32.1667 36.1419 21.5584 49.2086 13.8375C52.4169 14.2125 55.6128 15.8084 57.1211 18.6417C58.6586 21.5375 58.2169 25.1709 59.7503 28.0667C61.5461 31.4542 65.7211 33.025 69.5461 32.7792C73.3711 32.5334 76.9253 30.8042 80.3003 28.9917C90.8503 23.3292 100.825 16.5375 111.842 11.85C119.354 8.6542 127.567 6.49586 135.659 6.54586C161.138 16.2709 181.617 36.1125 192.184 61.1625L192.179 61.1667Z"
          fill="#204B7A"
        />
        <path d="M138.458 61.475H122.575V79.6375H138.458V61.475Z" fill="#FFC600" />
        <path d="M138.454 61.475H122.575L130.517 55.5916L138.454 61.475Z" fill="white" />
        <path
          d="M30.7004 78.9708C30.8638 78.9708 30.9962 78.8383 30.9962 78.675C30.9962 78.5116 30.8638 78.3791 30.7004 78.3791C30.537 78.3791 30.4045 78.5116 30.4045 78.675C30.4045 78.8383 30.537 78.9708 30.7004 78.9708Z"
          fill="white"
        />
        <path
          d="M143.75 74.9876H115.517V80.8126H145.517V74.9876H143.75ZM140.221 75.5751V79.6334H138.454V75.5751H140.221ZM136.692 75.5751V79.6334H134.925V75.5751H136.692ZM133.163 75.5751V79.6334H131.396V75.5751H133.163ZM129.634 75.5751V79.6334H127.867V75.5751H129.634ZM126.104 75.5751V79.6334H124.338V75.5751H126.104ZM122.575 75.5751V79.6334H120.809V75.5751H122.575ZM117.279 75.5751H119.046V79.6334H117.279V75.5751ZM141.984 79.6334V75.5751H143.75V79.6334H141.984Z"
          fill="white"
        />
        <path d="M138.458 61.475H122.575V62.65H138.458V61.475Z" fill="white" />
        <path
          d="M125.358 72.6624C127.471 72.6624 129.183 70.9499 129.183 68.8374C129.183 66.7249 127.471 65.0124 125.358 65.0124C123.246 65.0124 121.533 66.7249 121.533 68.8374C121.533 70.9499 123.246 72.6624 125.358 72.6624Z"
          fill="white"
        />
        <path
          d="M120.708 96.2541C121.337 90.8291 131.9 87.9457 134.925 109.329C137.954 130.712 140.308 153.237 140.308 153.237H146.912L138.875 83.7541H122.154L120.708 96.2541Z"
          fill="#C0C0C0"
        />
        <path
          d="M122.575 66.2083V71.4666L90.7791 77.8958L0.0708008 96.2375C0.487467 84.9125 2.79163 74.0708 6.6708 64.0125C9.11663 62.9375 12.2541 62.4875 14.925 62.3708H14.9541C23.4833 62.0083 31.8416 64.5375 40.0291 66.9458C48.2208 69.3625 56.6583 71.7125 65.1666 71C74.9625 70.1791 83.6291 65.4833 92.0708 60.0375L122.571 66.2041L122.575 66.2083Z"
          fill="#D6E1EF"
        />
      </g>
      <defs>
        <clipPath id="clip0_13144_150815">
          <rect width="200" height="200" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default UnauthorizedIcon;
